



































































































































































































































































































































































import Vue, { VNode, CreateElement } from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import DefconProgress from './defcon-progress.vue';
import MswProductDetail from './msw-product-detail/product-detail.vue';
import {
    SortedColumnInfo, TableColumnConfig, TableEntry, TableEntrySelectingEventData, ColumnSortRequestData, ColumnsAdjustRequestData, SwTable,
  } from '@libs-uuif/shared/sw-table';
import UUIFComponents from '@/shared/uuifComponent';
import { SwDropDownThreeComponent } from '../../../shared/dropdown-three-component';
import DropdownLight from '../../../shared/dropdown-light/dropdown-light.vue';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { State, Mutation } from 'vuex-class';
import { RootStoreState } from '@/store';
import { InfoState, SetHelpContentIdPayload } from '@/core/core.store';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import TransferProduct from './transfer-product.vue';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { currentUserKey } from '@/shared/msw-constants';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import DeleteProduct from '../components/delete-product.vue';
import UpdateZeroTouch from '../components/update-zt.vue';
import { SwTransitionExpand } from '@libs-uuif/shared/sw-transition';
import FileUpload from '@/modules/msw-products/components/file-upload.vue';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwDatetimePicker, DateTimePickerConfig } from '@libs-uuif/shared/sw-datetime-picker';
import { defaultSelectedCustomer } from '../products.store';
import  MswProductFreetrial   from './msw-product-freetrial/products-freetrial.vue';
import { SwContentToolbar, SwContentToolbarExpand, ContentToolbarExpandFilterBlock } from '@libs-uuif/shared/sw-content-toolbar';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwSlider } from '@libs-uuif/shared/sw-slider';
import { SwChip } from '@libs-uuif/shared/sw-chip';
import FileUploadmodal from './file-uploadmodal.vue';
import BulkActivation from './msw-bulkactivation/bulkactivation.vue';
// import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';

interface ViewDescriptor {
  key: string;
  label: string;
}

import { envCongif } from '@/shared/env.config';
import { TabProps, TabRenderData } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import SwTableBody from '@sonicwall/unified-ui-framework/src/shared/sw-table/sw-table-body.vue';
import MsspMonthlyManagedDialog from './msw-product-detail/conifrmMSSPMonthlyManagedDialog.vue';
import { SwDropMenu, DropMenuItem } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { PRODUCT_PAGE } from '@/shared/constants';
// import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
const cssPrefix = 'products-tab';
const INITIAL_LOAD_DATA = 50;
const LIMIT_INITIAL_LOAD_DATA = 500;
@Component({
  components: {
    ...UUIFComponents,
    DefconProgress,
    MswProductDetail,
    SwDropDownThreeComponent,
    DropdownLight,
    TransferProduct,
    DeleteProduct,
    UpdateZeroTouch,
    FileUpload,
    MsspMonthlyManagedDialog,
    MswProductFreetrial,
    SwTransitionExpand,
    SwBlockingProgress,
    SwDatetimePicker,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwForm,
    SwFormRow,
    SwRadio,
    SwExpandableTextfield,
    SwSlider,
    SwChip,
    FileUploadmodal,
    BulkActivation,
    SwDropMenu,
  }, directives: {
    tooltip,
  },
})
export default class MswProductsTab extends SwExtendedVue{
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  selectedSerialNumer: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  cssPrefix = cssPrefix;
  PRODUCT_PAGE = PRODUCT_PAGE;
  shieldValue = 0;
  defConProgressValue = 0;
  screenWidth: number;
  // ----------- Table --------------
  tableData: TableEntry[] = [];
  partialTableData: TableEntry[] = [];
  productsList: any[] = [];
  productTypesList: any[] = [];
  selectedTableRows: any[] = [];
  sortedColumns: SortedColumnInfo[] = [{
    colKey: 'registrationDate',
    ascending: true,
  }];
  isLoadingTableData: boolean = false;
  isLoadingPartialDataset: boolean = false;
  isProductsLoadingInBackground: boolean = false;
  totalProductCount: number = 0;
  filterResultCount: number = 0;
  isAllProductsLoaded: boolean = false;
  showMultiServiceActivation = false;
  showMSSPMonthlyManagedDialog: boolean = false;
  exportMenuOpened: boolean = false;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: (this.$t('products.exportCSV')
      .toString()) },
    { id: 'xls', content: (this.$t('products.exportXLS')
      .toString()) },
  ];

  @State((state: RootStoreState) => state.MswProductsStoreModule.searchInputChips)
  searchInputChips: string[];
  removeInputChip() {
    this.mutateFilterState('searchInputChips', []);
    this.applyFilters();
  }
  handleSearchFilter() {
    this.mutateFilterState('searchInputChips', [this.searchInputText]);
    this.searchInputText = '';
    this.isExpandSearchFilter = false;
    this.apiRequestLimiter = 0;
    this.applyFilters();
  }

  // ----------- Pagination -------------
  pageSize: number = 50;
  pageNumber: number = 1;
  loadMoreProducts: boolean = false;

  // ----------- Customer/Tenant Filter -----------
  defaultSelectedCustomer: string = defaultSelectedCustomer;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedCustomer)
  selectedCustomer: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedCustomerId)
  selectedCustomerId: string;
  customerList: any[] = [];
  // ----------------
  openDropMenu: boolean = false;
  openMultiProductAction: 'transfer'|'delete'|'updatezt'|'' = '';
  isOpenFileUpload: boolean = false;
  csvUploadErrorMsg: string = '';
  flipOptionsMenu:boolean;
  expiryAlerts: string = '0';
  selectedProductTab: string = '';
  selectedProductsForActions: any[] = [];
  customerToExcludeInTransfer: string = '';
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  inEligibleProductsForAction: any[] = [];
  openDeleteProduct: boolean = false;
  openUpdateZT: boolean = false;
  displayProductDetail:boolean = false;
  productGroupId:any;
  openBulkActivationDialog:boolean = false;
  hideTableWhileLoading : boolean = false;
  isTz:boolean = false;
  // Date Filter
  @State((state: RootStoreState) => state.MswProductsStoreModule.registeredOnSelectValue)
  registeredOnSelectValue: string;
  dateFilterCategories: string[] = ['All', 'Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Last 90 days', 'Last 180 days'];
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedDateRange)
  selectedDateRange: string;
  isRangeChanged: boolean = false;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productTypeSelectValue)
  productTypeSelectValue: string;
  dateRangeChanged(value: any, dragOrStep: any) {
    this.isRangeChanged = true;
    this.mutateFilterState('customDateFilter', '');
    this.mutateFilterState('registeredOnSelectValue', 'all');
    this.mutateFilterState('selectedDateRange', value);
    this.mutateFilterState('regDtRangeValue', '');
    this.mutateFilterState('regDtStartDate', '');
    this.mutateFilterState('regDtEndDate', '');
    this.handleDateFilter(value, 'registeredOn');
    if (dragOrStep === 'step') {
      this.dateRangeDragDone();
    }
    this.applyFilters();
  }
  dateRangeDragDone() {
    if (this.isRangeChanged) {
      this.resetTableData();
      this.loadProductList();
    }
    this.isRangeChanged = false;
  }
  @State((state: RootStoreState) => state.MswProductsStoreModule.customDateFilter)
  customDateFilter: string;
  onSelectCustomDtFilter(value: any) {
    this.mutateFilterState('customDateFilter', value);
    setTimeout( // wait till the component is mounted
      () => {
        const datepicker = (this.$refs.refDateTimePicker as SwDatetimePicker);
        // datepicker.isClickPopoverVisible = true;
        datepicker.$listeners.blur = () => { this.mutateFilterState('customDateFilter', ''); };
      },
      250,
    );
  }

  // ---------------- Widths and sort data
  // widths = this.$store.getters['MswProductsStoreModule/getWidths'];
  @State((state: RootStoreState) => state.MswProductsStoreModule.widths)
  widths: any;
  @State((state: RootStoreState) => state.MswProductsStoreModule.sortData)
  sortData: any[];
  // ----------------

  // Custom range filter
  @State((state: RootStoreState) => state.MswProductsStoreModule.regDtRangeValue)
  regDtRangeValue: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.regDtStartDate)
  regDtStartDate: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.regDtEndDate)
  regDtEndDate: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.lastRegFilterIdSelected)
  lastRegFilterIdSelected: string;
  regDtRangePickerConfig: DateTimePickerConfig = {
    type: 'date',
    placeholder: (this.$t('products.selectDateTime')
    .toString()),
    dateFormat: 'MM/DD/YYYY',
    pane: 2,
    enableRange: true,
  };
  // ----------------

  // Search Filter
  isExpandSearchFilter: boolean = false;
  searchInputText: string = '';
  searchIconForFilterInput = { name: 'search', style: { color: '#ff791a', cursor: 'pointer', marginRight: '10px' } };
  clearSearchIconForFilterInput = {
    name: 'close', style: { color: 'red', fontWeight: 'bold', size: 'small', cursor: 'pointer', marginRight: '10px' },
  };
  activeFilterButtons: TabProps[] = [
    { tabId: 'total', label: '', innerRender: this.filterTabRenderer },
    { tabId: 'expiring', label: '', innerRender: this.filterTabRenderer },
    { tabId: 'updates', label: '', innerRender: this.filterTabRenderer },
  ];
  activeFilterButtonStatus: 'total'|'expiring'|'updates' = 'total';

  // Content bar filter
  expandVisible: boolean = false;
  viewProductTypeFilterValues : any = [];
  @State((state: RootStoreState) => state.MswProductsStoreModule.expiringOnSelectValue)
  expiringOnSelectValue: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.expiringOnSelectVal)
  expiringOnSelectVal: string;
  expiringOnCategories: string[] = ['All', 'Last 180 days',  'Last 90 days', 'Last 30 days', 'Last 7 days',  'Yesterday', 'Today',
    'Next 7 days', 'Next 30 days', 'Next 90 days', 'After next 90 days'];
  @State((state: RootStoreState) => state.MswProductsStoreModule.firmwareFilterValue)
  firmwareFilterValue: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.cloudBackupsSelectedValue)
  cloudBackupsSelectedValue: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.ztTypeSelectedValue)
  ztTypeSelectedValue: string;
  get filterChipsConditions() {
    return {
      ProductType: this.productTypeSelectValue.toLowerCase() !== 'all',
      RegisteredOn: this.regDtRangeValue || ((this.selectedDateRange && this.selectedDateRange.toLowerCase() !== 'all')),
      ExpiryIn: this.expiringOnSelectVal && this.expiringOnSelectVal.toLowerCase() !== 'all',
      FirmwareVersion: this.firmwareFilterValue,
      ZeroTouchType: this.ztTypeSelectedValue && this.ztTypeSelectedValue.toLowerCase() !== 'all',
      cloudBackups: this.cloudBackupsSelectedValue && this.cloudBackupsSelectedValue.toLowerCase() !== 'all',
    };
  }
  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
    this.closeProductDetail(false);
  }
  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        { title: (this.$t('products.productsType')
        .toString()), content: this.viewProductTypeFilterRender, width: 200  },
        { title: (this.$t('products.registeredon')
        .toString()), content: this.viewRegisteredOnFilterRender, width: 300 },
        { title: (this.$t('products.customDateRange')
        .toString()), content: this.viewDateRangeFilterRender, width: 210 },
        { title: (this.$t('products.headerExpiryIn')
        .toString()), content: this.viewExpiryTimeFilterRender, width: 300 },
        { title: (this.$t('products.currentversion')
        .toString()), content: this.viewFirmwareFilterRenderer, width: 170 },
        { title: (this.$t('registerProduct.zt')
        .toString()), content: this.viewZeroTouchFilterRenderer, width: 160 },
        { title: (this.$t('products.cloudBackupsStored')
        .toString()), content: this.cloudBackupsFilterRenderer, width: 180 },
      ],
    ];
  }
  get viewProductTypeDesc(): ViewDescriptor[] {
    return this.viewProductTypeFilterValues.map((val: any) => {
      return {
        key: val,
        label: val,
      };
    });
  }
  private viewProductTypeFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.viewProductTypeDesc.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name : val.label,
                        value : val.key,
                        pickedValue : this.productTypeSelectValue,
                      },
                      nativeOn: {
                        change: (event : any) => {
                          const clickedValue = event.target.value;
                          this.mutateFilterState('productTypeSelectValue', clickedValue ? clickedValue : val.key);
                          this.applyFilters();
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
                <div class={['sw-flexbox__flex-none', 'csc-filter-item-subtotal']}>{ val.count }</div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  private viewExpiryTimeFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwSlider
          {...{
            props: {
              categories : this.expiringOnCategories,
              value : this.expiringOnSelectValue,
              size: 'large',
              withDropdown: true,
            },
            attrs: {
              title: this.expiringOnSelectValue,
            },
            on: {
              change: (event : any) => {
                this.mutateFilterState('expiringOnSelectValue', event);
                this.handleDateFilter(event, 'expiringOn');
                this.applyFilters();
              },
            },
          }}></SwSlider>
      </div>
    ) as VNode;
  }

  private viewRegisteredOnFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwSlider
          {...{
            props: {
              categories : this.dateFilterCategories,
              value : this.selectedDateRange,
              size: 'large',
              withDropdown: true,
            },
            attrs: {
              title: this.selectedDateRange,
            },
            on: {
              change: this.dateRangeChanged,
              'drag-done': this.dateRangeDragDone,
            },
          }}></SwSlider>
      </div>
    ) as VNode;
  }

  private viewDateRangeFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
      <SwDatetimePicker
        {...{
          props: {
            value: this.regDtRangeValue,
            pickerConfig: this.regDtRangePickerConfig,
          },
          on: {
            input: this.regDateRangeChanged,
          },
        }}>
      </SwDatetimePicker>
      </div>
    ) as VNode;
  }

  get showFiltersApplied() {
    let condition = false;
    Object.keys(this.filterChipsConditions)
    .forEach((key) => {
      // @ts-ignore
      condition = condition || this.filterChipsConditions[key];
    });
    return this.searchInputChips.length || condition;
  }

  viewFirmwareFilterRenderer(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'firmwareVersionFilter',
              value: this.firmwareFilterValue,
              placeholder:(this.$t('products.version')
              .toString()),
            },
            style: {
              width: '100px',
            },
            on: {
              keyup: (event :any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('firmwareFilterValue', event.trim());
              },
            },
          }}>
        </SwTextfield>
      </div>
    ) as VNode;
  }

  viewZeroTouchFilterRenderer(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          [{ key: 'all', label: (this.$t('products.all')
            .toString()) }, { key: 'csc', label: 'CSC' }, { key: 'gms', label: 'GMS' }, { key: 'none', label: (this.$t('products.none')
            .toString()) }].map<VNode>((val: any) => {
              return (
                <SwFormRow no-label>
                  <div class={['sw-flexbox__flex']}>
                    <SwRadio
                      {...{
                        props: {
                          name : val.label,
                          value : val.key,
                          pickedValue : this.ztTypeSelectedValue,
                        },
                        nativeOn: {
                          change: (event : any) => {
                            const clickedValue = event.target.value;
                            this.mutateFilterState('ztTypeSelectedValue', clickedValue ? clickedValue : val.key);
                            this.applyFilters();
                          },
                        },
                      }}> { val.label } </SwRadio>
                  </div>
                  <div class={['sw-flexbox__flex-none', 'csc-filter-item-subtotal']}>{ val.count }</div>
                </SwFormRow>
              ) as VNode;
            })
          }
      </SwForm>
    ) as VNode;
  }

  cloudBackupsFilterRenderer(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          [{ key: 'all', label: (this.$t('products.all')
            .toString()) }, { key: 'YES', label: 'YES' }, { key: 'NO', label: 'NO' }].map<VNode>((val: any) => {
              return (
                <SwFormRow no-label>
                  <div class={['sw-flexbox__flex']}>
                    <SwRadio
                      {...{
                        props: {
                          name : val.label,
                          value : val.key,
                          pickedValue : this.cloudBackupsSelectedValue,
                        },
                        nativeOn: {
                          change: (event : any) => {
                            const clickedValue = event.target.value;
                            this.mutateFilterState('cloudBackupsSelectedValue', clickedValue ? clickedValue : val.key);
                            this.applyFilters();
                          },
                        },
                      }}> { val.label } </SwRadio>
                  </div>
                  <div class={['sw-flexbox__flex-none', 'csc-filter-item-subtotal']}>{ val.count }</div>
                </SwFormRow>
              ) as VNode;
            })
          }
      </SwForm>
    ) as VNode;
  }
  // -------------

  updatesAvailable: string = '';
  displayFreeTrial:boolean = false;

  created() {
    this.isIframed = location !== parent.location;
    this.screenWidth = this.isIframed ? (innerWidth + 235) : innerWidth;
  }

  refreshList() {
    this.loadProductList('YES', true, true, true);
  }

  mounted() {
    document.addEventListener('click', this.closeUploadModal);
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        this.closeModals();
      }
    });
    this.isLoadingTableData = true;
    if (this.$store.getters['TenantManagementStoreModule/getProductCreated']) {
      this.loadProductList('YES', true, true, true);
      this.$store.commit('TenantManagementStoreModule/setProductCreated', { productCreated: false });
    }
    this.handleTableScroll();
    this.setHelpId('products');
    this.resetFilters();
    this.resetTableData();
    if (this.$route.query.serialNumber) {
      this.displayProductDetail = true;
      if (this.$route.query.tab) {
        this.selectedProductTab = this.$route.query.tab
                                      .toString()
                                      .toLowerCase();
        if (this.selectedProductTab === 'firmware' || this.selectedProductTab === 'licenses' || this.selectedProductTab === 'cloudbackups') {
          this.$store.commit('MswProductsStoreModule/setSkipLoading', 'YES');
        }
      }
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedSerialNumer', with: this.$route.query.serialNumber.toString() });
      this.mutateFilterState('selectedColumnKeys', this.productTableConfig.map(col => col.key));
      if (this.$route.query.forceFetch) {
        this.loadProductList('NO', true);
      } else {
        this.loadProductList('NO', false);
      }
    } else if (this.$route.query.tenant) {
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: this.$route.query.tenant.toString() });
      this.mutateFilterState('selectedColumnKeys', this.productTableConfig.map(col => col.key));
      this.setColumnConfigAfterCustomersColRemoval();
      this.loadProductList('YES', false, false, false, true);
    } else if (this.$route.query.tenantid) {
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: this.$route.query.tenantid.toString() });
      this.mutateFilterState('selectedColumnKeys', this.productTableConfig.map(col => col.key));
      this.setColumnConfigAfterCustomersColRemoval();
      this.loadProductList('YES', false, false, false, true);
    } else {
      if (this.$route.query.tab === 'expiring') {
        this.activeFilterButtonStatus = this.$route.query.tab;
        this.mutateFilterState('selectedColumnKeys', this.productTableConfig.map(col => col.key));
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: defaultSelectedCustomer });
        this.loadProductList();
      } else {
        this.getFilterStateAndLoadProducts(); // Get any saved filters and apply on the products api request
      }
    }
    if (this.$route.query.success) {
      const message: InfoState = { infoType: 'success', infoMsg: this.$route.query.success.toString() };
      this.$store.commit('enqueueMessage', message);
    }
  }

  getFilterStateAndLoadProducts() {
    this.mutateFilterState('selectedColumnKeys', this.productTableConfig.map(col => col.key));
    this.$store.dispatch('MswProductsStoreModule/saveFilterState', {
      columnNames: '',
    })
    .then((resp) => {
      if (resp.content.columnNames && resp.content.columnNames !== 'YES') {
        const filtersState = atob(resp.content.columnNames);
        const parsed = JSON.parse(filtersState);
        this.setColumWidths(parsed);
        this.setSortData(parsed);
        this.$store.commit('MswProductsStoreModule/setFiltersState', JSON.parse(filtersState));
      }
      this.loadProductList('YES', true, true, true);
    });
    this.setColumnConfigAfterCustomersColRemoval();
  }

  setColumWidths(res: any) {
    const keyArr = res.widths ? Object.keys(res.widths) : '';
    this.productTableConfig.forEach((el) => {
      if (keyArr.includes(el.key)) {
        if (res.widths[el.key] !== '') {
          el.width = res.widths[el.key];
        }
      }
    });
  }

  setSortData(res: any) {
    this.sortedColumns = res.sortData;
  }

  mutateFilterState(prop: string, value: any) {
    this.$store.commit('MswProductsStoreModule/mutate', {
      property: prop, with: value,
    });
  }

  saveOrResetFilterState(isReset: boolean = false) {
    // this.$store.commit('startLoading');
    const resetData = this.$store.getters['MswProductsStoreModule/getInitialFiltersState'];
    const filtersState = {
      selectedCustomer: isReset ? resetData.selectedCustomer : this.selectedCustomer,
      productTypeSelectValue: isReset ? resetData.productTypeSelectValue : this.productTypeSelectValue,
      selectedDateRange: isReset ? resetData.selectedDateRange : this.selectedDateRange,
      registeredOnSelectValue: isReset ? resetData.registeredOnSelectValue : this.registeredOnSelectValue,
      searchInputChips: isReset ? resetData.searchInputChips : this.searchInputChips,
      customDateFilter: isReset ? resetData.customDateFilter : this.customDateFilter,
      regDtRangeValue: isReset ? resetData.regDtRangeValue : this.regDtRangeValue,
      regDtStartDate: isReset ? resetData.regDtStartDate : this.regDtStartDate,
      regDtEndDate: isReset ? resetData.regDtEndDate : this.regDtEndDate,
      lastRegFilterIdSelected: isReset ? resetData.lastRegFilterIdSelected : this.lastRegFilterIdSelected,
      selectedColumnKeys: isReset ? this.productTableConfig.map(col => col.key) : this.selectedColumnKeys,
      expiringOnSelectValue: isReset ? resetData.expiringOnSelectValue : this.expiringOnSelectValue,
      expiringOnSelectVal: isReset ? resetData.expiringOnSelectVal : this.expiringOnSelectVal,
      firmwareFilterValue: isReset ? resetData.firmwareFilterValue : this.firmwareFilterValue,
      ztTypeSelectedValue: isReset ? resetData.ztTypeSelectedValue : this.ztTypeSelectedValue,
      cloudBackupsSelectedValue: isReset ? resetData.cloudBackupsSelectedValue : this.cloudBackupsSelectedValue,
      widths: isReset ? {} : this.widths,
      sortData: isReset ? [] :  this.sortData,
    };
    this.$store.dispatch('MswProductsStoreModule/saveFilterState', {
      columnNames: btoa(JSON.stringify(filtersState)),
    })
    .then(() => {
      // this.$store.commit('stopLoading');
      // const message: InfoState = { infoType: resp.msgCode === 'MSWAPP:SUCCESS' ? 'success' : 'high', infoMsg: resp.msgDesc };
      // this.$store.commit('enqueueMessage', message);
      if (isReset) {
        this.resetTableData();
        this.getFilterStateAndLoadProducts();
      }
    });
  }

  isIframed:boolean = false;
  dataMoreActions: { actionsMenuClientX: Number, actionsMenuClientY: Number, rowData: any } = { actionsMenuClientX: 0, actionsMenuClientY: 0, rowData: {} };
  opt2 = {
    steps:[
      {
        element:'#total__products',
        intro:'Filter your products based on expiry alerts and product updates.',
        position:'bottom',
        tooltipClass:'total_products',
      },
      {
        element:'#msw-products-table',
        intro:'View all registered products with expiry and update alerts.',
        position:'left',
        tooltipClass:'products_tables  last',
      },
    ],
  };
  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;
  actionsDropMenuItems = [
    { id: 'item1', content: 'Menu Item 1' },
    { id: 'item2', content: 'Menu Item 2' },
    { id: 'item3', content: 'Menu Item 3' },
    { id: 'item4', content: 'Menu Item 4' },
    { id: 'item5', content: 'Menu Item 5' },
    { id: 'item6', content: 'Menu Item 6' },
  ];

  tableConfigArr: TableColumnConfig[] = [{
    key: 'selection',
    type: 'selection',
  }, {
    key: 'friendlyName',
    dataKey: 'friendlyName',
    title: (this.$t('products.friendlyName')
    .toString()),
    sorter: true,
    width: 220,
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => this.friendlyNameColumnRenderer(h, data),
  }, {
    key: 'serNo',
    dataKey: 'serNo',
    title: (this.$t('products.productSerialNumber')
    .toString()),
    sorter: true,
    width: 170,
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
      return (
        <div class="serial_col_text" onClick={() => { this.openProductDetail(data.entry.serNo, 'productdetails', data.entry.productType); }}>
          <div style="flex: 1;">{ data.entry.serNo }</div>
          <div class={ data.entry.isSharedProduct === 'YES' ? 'shared_prod' : ''}
            v-tooltip={{ placement: 'right', persistent: false, compact: true, content: 'Shared Product' }}>
          </div>
          {
            data.entry.isMSSPProduct && data.entry.isMSSPProduct === 'YES' ?
            <div v-tooltip={{
              placement: 'top',
              persistent: false,
              compact: true,
              content: `${this.$t('products.msspSerialInfo')
                .toString()}`,
            }}>
              <SwIcon props-size={16} name="info" color="#333"></SwIcon>
            </div> :
            null
          }
        </div>
      ) as VNode;
    },
  }, {
    key: 'productGroup',
    dataKey: 'productGroup',
    title: (this.$t('products.tenant')
    .toString()),
    sorter: true,
    width: 170,
    // tslint:disable-next-line:no-unused
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
      return (
        <div style="display:flex;justify-content:center;align-items:center;width: 100%;">
         <div style="margin-right:5px;"
         class={data.entry.sharedGroupHoverText !== '' ? 'sharedCustomer-dark' : ''}
         v-tooltip={{ content: data.entry.sharedGroupHoverText , compact: true }}></div>
          <div class="friendlyname_col_text">{ data.entry.productGroup.replace(/&amp;/g, '&') }</div>
        </div>
      ) as VNode;
      // return createElement('div', { domProps: { innerHTML: data.entry.productGroup } });
    },
  }, {
    key: 'productType',
    dataKey: 'productType',
    title: (this.$t('products.productTypeHeader')
    .toString()),
    sorter: true,
    width: 175,
    className: `${cssPrefix}__capitalize_text`,
    render: (createElement, data: { entry: TableEntry }) => {
      return createElement('div', {
        domProps: { innerHTML: data.entry.productType ? data.entry.productType : '' },
      });
    },
  }, {
    key: 'productName',
    dataKey: 'productName',
    title: (this.$t('products.productName')
    .toString()),
    sorter: true,
    width: 200,
    render: (createElement, data: { entry: TableEntry }) => {
      return createElement('div', { domProps: { innerHTML: data.entry.productName } });
    },
  }, {
    key: 'registrationDate',
    dataKey: 'dtRegistrationDate',
    sorter: true,
    title: (this.$t('products.registeredon')
    .toString()),
    width: 150,
    render: (createElement, data: { entry: TableEntry }) => {
      return createElement('div', { domProps: { innerHTML: data.entry.registrationDate } });
    },
  }, {
    key: 'casNodeCount',
    dataKey: 'casNodeCount',
    title: (this.$t('products.licenses')
    .toString()),
    width: 95,
    sorter: (a: any, b: any): number => {
      const sortOne = Number(a.ccNodeCount === 'Unlimited' ? -1 : a.ccNodeCount) +
        Number(a.hesNodeCount === 'Unlimited' ? -1 : a.hesNodeCount) +
        Number(a.gmsNodeCount === 'Unlimited' ? -1 : a.gmsNodeCount) +
        Number(a.casNodeCount === 'Unlimited' ? -1 : a.casNodeCount) +
        Number(a.saseNodeCount === 'Unlimited' ? -1 : a.saseNodeCount);
      const sortTwo = Number(b.ccNodeCount === 'Unlimited' ? -1 : b.ccNodeCount) +
        Number(b.hesNodeCount === 'Unlimited' ? -1 : b.hesNodeCount) +
        Number(b.gmsNodeCount === 'Unlimited' ? -1 : b.gmsNodeCount) +
        Number(b.casNodeCount === 'Unlimited' ? -1 : b.casNodeCount) +
        Number(b.saseNodeCount === 'Unlimited' ? -1 : b.saseNodeCount);
      return sortOne - sortTwo;
    },
    render: (createElement, data: { entry: TableEntry }) => {
      const dataEntry = data.entry;
      const nodeCountItems = [];
      for (const key in dataEntry) {
        if (dataEntry.hasOwnProperty(key)) {
          if (key.indexOf('NodeCount') > 0) {
            nodeCountItems.push(dataEntry[key]);
          }
        }
      }
      const isUnlimited = nodeCountItems.some((item) => {
        return item === 'Unlimited';
      });

      return createElement('div', {
        domProps: {
          innerHTML: isUnlimited ? 'Unlimited' :
            Number(data.entry.ccNodeCount ? data.entry.ccNodeCount : 0) +
            Number(data.entry.hesNodeCount ? data.entry.hesNodeCount : 0) +
            Number(data.entry.gmsNodeCount ? data.entry.gmsNodeCount : 0) +
            Number(data.entry.casNodeCount ? data.entry.casNodeCount : 0) +
            Number(data.entry.saseNodeCount ? data.entry.saseNodeCount : 0),
        },
      });
    },
  }, {
    key: 'supportExpiry',
    dataKey: 'dtSupportExpiry',
    title: (this.$t('common.support')
    .toString()),
    width: 120,
    sorter: true,
    render: (createElement, data: { entry: TableEntry }) => {
      return createElement('div', { domProps: { innerHTML: data.entry.supportExpiry } });
    },
  }, {
    key: 'firmwareVersion',
    dataKey: 'firmwareVersion',
    title: (this.$t('products.firmware')
    .toString()),
    // width: 120,
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => this.firmwareColumnRenderer(h, data),
  }, {
    key: 'Hascloudbackups',
    dataKey: 'Hascloudbackups',
    title: (this.$t('products.cloudBackupsStored')
    .toString()),
    sorter: true,
    width: 170,
  }, {
    key: 'actions',
    dataKey: 'actions',
    title: (this.$t('products.actions')
    .toString()),
    className: `${cssPrefix}__actions_column`,
    render: (h: CreateElement, data: { entry: TableEntry }): VNode => this.actionsColumnRenderer(h, data),
    width: 120,
  },
  ];
  productTableConfig: TableColumnConfig[] = this.tableConfigArr;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedColumnKeys)
  selectedColumnKeys: string[];
  showDefconDialog: boolean = false;
  defconDialogSrc: string = '';
  visible: boolean = false;
  apiRequestLimiter: number = 0;
  get selectedColumnsConfig(): TableColumnConfig[] {
    return this.productTableConfig.filter(col => (this.selectedColumnKeys.includes(col.key)));
  }

  getProductsReqBody(isPaged: string, forceFetch: boolean = false, clearMangoCache: boolean = false) {
    return { isPaged, forceFetch, pageSize: this.pageSize, pageNumber: this.pageNumber,
      productGroupName: this.selectedCustomer === this.defaultSelectedCustomer ? '' : this.selectedCustomer,
      filterByProductType: this.productTypeSelectValue === 'All' ? '' : this.productTypeSelectValue,
      lastRegistered: this.registeredOnSelectValue === 'all' || this.registeredOnSelectValue === 'custom' ? '-1' : this.registeredOnSelectValue,
      showExpiredProducts: this.activeFilterButtonStatus === 'expiring',
      friendlyNameOrSerial: this.searchInputChips[0] ? this.searchInputChips[0] : '',
      showDownloadsAvailable: this.activeFilterButtonStatus === 'updates',
      startDate: this.regDtStartDate && this.registeredOnSelectValue === 'custom' ? this.regDtStartDate : '',
      endDate: this.regDtEndDate && this.registeredOnSelectValue === 'custom' ? this.regDtEndDate : '',
      isForced : clearMangoCache,
    };
  }

  // tslint:disable-next-line:no-unused
  // tslint:disable-next-line:max-line-length
  loadProductList(isPaged: string = 'YES', forceFetch: boolean = false, clearMangoCache: boolean = false, calledFromReload :boolean = false, hideTableWhileLoading: boolean = false) {
    this.deSelectRows();
    this.isLoadingTableData = true;
    this.$store.dispatch(
      'MswProductsStoreModule/getProductsList', this.getProductsReqBody(isPaged, forceFetch, clearMangoCache),
    )
    .then((res) => {
      // getting all fresh data from the API so deleting local forage
      if (calledFromReload && forceFetch) {
        localStorage.removeItem('registeredData');
        localStorage.removeItem('deleteProductData');
        localStorage.removeItem('locallyTransferedProduct');
      }
      if (!hideTableWhileLoading) {
        this.assignResponse(res);
      }
      if (this.isAllProductsLoaded && !forceFetch) {
        this.applyLocalFilters();
      } else {
        if (!this.isProductsLoadingInBackground) {
          this.loadAllProductsInBackground(hideTableWhileLoading);
        }
      }
      if (!hideTableWhileLoading) {
        setTimeout(() => { this.isLoadingTableData = false; }, 0);
      }
    })
    .catch(() => {
      this.isLoadingTableData = false;
    });
  }

  loadAllProductsInBackground(hideTableWhileLoading : boolean = false) {
    this.isProductsLoadingInBackground = true;
    this.$store.dispatch(
    'MswProductsStoreModule/getProductsList', { isPaged:'NO', productGroupName:'', filterByProductType:'', lastRegistered:'-1', forceFetch: true },
    )
    .then((res) => {
      // this.disableExport = false;
      this.isProductsLoadingInBackground = false;
      if (this.$route.query.tenantName) {
        this.updateEmptyTenantName(res);
      }
      this.assignResponse(res);
      this.applyLocalFilters();
      if (hideTableWhileLoading) {
        setTimeout(() => { this.isLoadingTableData = false; }, 0);
      }
    });
  }

  updateEmptyTenantName(response: any) {
    const index = response.prodList.findIndex((item: any) => { return item.serNo === this.selectedSerialNumer; });
    if (index > -1) {
      const prodGroupName = response.prodList[index].productGroup;
      if (!prodGroupName) {
        response.prodList[index].productGroup = this.$route.query.tenantName;
        this.saveLocalDbAndReloadTable(response);
      }
    }
  }

  saveLocalDbAndReloadTable(data: any) {
    this.$store.dispatch('MswProductsStoreModule/saveProductsList', data)
    .then(() => {
      this.loadProductList();
    });
  }

  openBulkActivation() {
    this.openBulkActivationDialog = true;
  }

  onLoadMoreProducts(minNumToLoad: number) {
    if (this.isLoadingPartialDataset) { return; }
    this.loadMoreProducts = true;
    this.loadDataInParts(this.partialTableData.length, Math.max(minNumToLoad, 20))
    .then(() => {
      this.loadMoreProducts = false;
    });
  }

  loadDataInParts(start: number, length: number, fromFilter: boolean = false) {
    if (length <= 0) {
      if (fromFilter) this.partialTableData = this.tableData;
      return Promise.resolve(0);
    }
    this.isLoadingPartialDataset = true;
    return new Promise<number>((resolve: any) => {
      setTimeout(
      () => {
        let count = 0;
        if (start === 0) {
          this.partialTableData = [];
        }
        for (; count < length && (start + count) < this.tableData.length; count += 1) {
          this.partialTableData.push(this.tableData[start + count]);
        }
        this.isLoadingPartialDataset = false;
        resolve(count);
      },
      0,
      );
    });
  }

  handleDelete() {
    if (this.$store.getters.isLargeCustomer) {
      this.$store.dispatch('MswProductsStoreModule/getProductsList', this.getProductsReqBody('NO'))
      .then((res) => {
        const data = res;
        // localStorage.setItem('deleteProductData', JSON.stringify(this.selectedProductsForActions));
        const deleteProductDataCopy = localStorage.getItem('deleteProductData');
        if (deleteProductDataCopy !== undefined && deleteProductDataCopy !== null) {
          const reqArr = JSON.parse(deleteProductDataCopy);
          this.selectedProductsForActions.forEach((ele : any) => {
            reqArr.push(ele);
          });
          localStorage.setItem('deleteProductData', JSON.stringify(reqArr));
        } else {
          const reqArr : any = [];
          this.selectedProductsForActions.forEach((ele : any) => {
            reqArr.push(ele);
          });
          localStorage.setItem('deleteProductData', JSON.stringify(reqArr));
        }
        this.selectedProductsForActions.forEach((product: any) => {
          const index = data.prodList.findIndex((item: any) => { return item.serNo === product.serNo; });
          if (index > -1) {
            data.prodList.splice(index, 1);
          }
        });
        this.saveLocalDbAndReloadTable(data);
      });
    } else {
      this.resetTableData();
      this.loadProductList('YES', true);
    }
  }

  handleZeroTouchRefresh(data: any) {
    this.updateZeroTouchRefresh([data]);
  }

  updateZeroTouchRefresh(list: any[]) {
    this.$store.dispatch('MswProductsStoreModule/getProductsList', this.getProductsReqBody('NO'))
    .then((res) => {
      list.forEach((data) => {
        const index = res.prodList.findIndex((item: any) => { return item.serNo === data.entry.serNo; });
        if (index > -1) {
          if (res.prodList[index].ztValue) {
            res.prodList[index].ztValue = data.entry.ztValue;
          }
        }
      });
      this.saveLocalDbAndReloadTable(res);
    });
  }

  saveFriendlyNameListToStore(list: any[]) {
    this.$store.dispatch('MswProductsStoreModule/getProductsList', this.getProductsReqBody('NO'))
    .then((res) => {
      list.forEach((data) => {
        const index = res.prodList.findIndex((item: any) => { return item.serNo === data.entry.serNo; });
        if (index > -1) {
          res.prodList[index].friendlyName = data.entry.friendlyName;
        }
      });
      this.saveLocalDbAndReloadTable(res);
    });
  }

  handleTransfer(event: any) {
    if (event) {
      if (event.customer) {
        if (this.$store.getters.isLargeCustomer) {
          this.$store.dispatch('MswProductsStoreModule/getProductsList', this.getProductsReqBody('NO'))
          .then((res) => {
            const data = res;
            const locallyTransferedProduct = localStorage.getItem('locallyTransferedProduct');
            if (locallyTransferedProduct !== undefined && locallyTransferedProduct !== null) {
              const reqArr = JSON.parse(locallyTransferedProduct);
              this.selectedProductsForActions.forEach((ele : any) => {
                const obj = {
                  serNo : ele.serNo,
                  productGroup : event.customer.productGroupName,
                };
                reqArr.push(obj);
              });
              localStorage.setItem('locallyTransferedProduct', JSON.stringify(reqArr));
            } else {
              const reqArr : any = [];
              this.selectedProductsForActions.forEach((ele : any) => {
                const obj = {
                  serNo : ele.serNo,
                  productGroup : event.customer.productGroupName,
                };
                reqArr.push(obj);
              });
              localStorage.setItem('locallyTransferedProduct', JSON.stringify(reqArr));
            }
            this.selectedProductsForActions.forEach((product: any) => {
              const index = data.prodList.findIndex((item: any) => { return item.serNo === product.serNo; });
              if (index > -1) {
                data.prodList[index].productGroup = event.customer.productGroupName;
              }
            });
            this.saveLocalDbAndReloadTable(data);
          });
        } else {
          this.resetTableData();
          this.loadProductList('YES', true);
        }
      } else if (event.user) {
        this.handleDelete();
      }
    }
  }

  assignResponse(res: any) {
    if (this.$store.getters.isLargeCustomer) {
      const registeredData = localStorage.getItem('registeredData');
      if (registeredData !== undefined && registeredData !== null) {
        const registeredDataCopy = JSON.parse(registeredData);
        if (registeredDataCopy.length > 0) {
          registeredDataCopy.forEach((ele : any, index : any) => {
            const findIndex = res.prodList.findIndex((obj : any) => obj.serNo.trim()
            .toLowerCase() === ele.serNo
            .trim()
            .toLowerCase());
            if (findIndex === -1) {
              res.prodList.push(ele);
              res.totalProducts = parseInt(res.totalProducts, 10) + 1 ;
              res.totalProducts = res.totalProducts.toString();
              ele.id = res.totalProducts;
            } else {
              res.prodList[index].productGroup = ele.productGroup;
            }
          });
        }
      }
      const deleteProductData = localStorage.getItem('deleteProductData');
      if (deleteProductData !== undefined && deleteProductData !== null) {
        const deleteProductDataCopy = JSON.parse(deleteProductData);
        if (deleteProductDataCopy.length > 0) {
          deleteProductDataCopy.forEach((prod : any) => {
            const eleIndex = res.prodList.findIndex((ele : any) => ele.serNo.trim()
            .toLowerCase() === prod.serNo
            .trim()
            .toLowerCase());
            if (eleIndex !== -1) {
              res.prodList.splice(eleIndex, 1);
              res.totalProducts = parseInt(res.totalProducts, 10) - 1 ;
              res.totalProducts = res.totalProducts.toString();
            }
          });
        }
      }
      const locallyTransferedProduct = localStorage.getItem('locallyTransferedProduct');
      if (locallyTransferedProduct !== undefined && locallyTransferedProduct !== null) {
        const locallyTransferedProductCopy = JSON.parse(locallyTransferedProduct);
        if (locallyTransferedProductCopy.length > 0) {
          locallyTransferedProductCopy.forEach((ele : any) => {
            const findIndex = res.prodList.findIndex((obj : any) => obj.serNo.trim()
            .toLowerCase() === ele.serNo
            .trim()
            .toLowerCase());
            if (findIndex !== -1) {
              res.prodList[findIndex].productGroup = ele.productGroup;
            }
          });
        }
      }
    }
    this.productsList = res.prodList ? res.prodList : [];
    this.tableData = res.prodList ? res.prodList : [];
    this.isAllProductsLoaded = res.isAllProductsLoaded ? true : false;
    this.totalProductCount = res.totalProducts;
    this.filterResultCount = res.filterResultCount;
    const expiredProducts = res.expiredProducts ? Number(res.expiredProducts) : 0;
    const soonExpiringProducts = res.soonExpiringProducts ? Number(res.soonExpiringProducts) : 0;
    this.expiryAlerts = (expiredProducts + soonExpiringProducts).toString();
    this.updatesAvailable = res.downloadsAvailableCount ? res.downloadsAvailableCount : 0;
    this.productTypesList = res.productTypeList ? res.productTypeList : [];
    this.shieldValue = res.shieldLevelValue ? Number(res.shieldLevelValue) : 0;
    this.defConProgressValue = res.defconValue ? Number(res.defconValue) : 0;
    this.setProductTypeOptions();
    this.loadDataInParts(0, this.numberofRecordsToLoad);
  }

  editFriendlyName(data:any, isEditMode: boolean) {
    const idx = Number(data.index);
    const labelElement = document.getElementsByClassName('friendlyname_col_text_field')[idx] as HTMLElement;
    if (labelElement) labelElement.style.display = isEditMode ? 'none' : 'flex';
    const textBoxElement = document.getElementsByClassName('friendlyname_col_edit_text')[idx] as HTMLElement;
    if (textBoxElement) textBoxElement.style.display = isEditMode ? 'flex' : 'none';
  }

  renameProduct(data: any) {
    this.$store.commit('startLoading');
    const renamelist = [{ serialNumber: data.entry.serNo, newName: data.entry.friendlyName }];
    this.$store.dispatch(
      'MswProductsStoreModule/renameFriendlyName', { prodsRenamelist: renamelist },
    )
    .then((res) => {
      if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.handleFriendlyNameRefresh(data);
      } else if (res.msgCode === 'MSWAPP:PRODSRENAMEFAILURE') {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        data.entry.friendlyName = data.entry.friendlyNameBeforeEdit;
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: (this.$t('products.renameFailed')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
        data.entry.friendlyName = data.entry.friendlyNameBeforeEdit;
      }
      this.$store.commit('stopLoading');
    });
  }

  handleFriendlyNameRefresh(data: any) {
    if (this.$store.getters.isLargeCustomer) {
      this.saveFriendlyNameListToStore([data]);
    } else {
      this.resetTableData();
      this.loadProductList('YES', true);
      // idb.refreshStore(PRODUCTS_STORE_NAME);
    }
  }

  setProductTypeOptions() {
    this.viewProductTypeFilterValues = ['All'];
    this.productTypesList.sort((a1, a2) => { // sorting to be in alphabetical order
      const newA1 = a1.productTypeName.toUpperCase();
      const newA2 = a2.productTypeName.toUpperCase();
      if (newA1 > newA2) {
        return 1;
      }
      if (newA1 < newA2) {
        return -1;
      }
      return 0;
    });
    this.productTypesList.forEach((type) => {
      this.viewProductTypeFilterValues.push(type.productTypeName);
    });
  }

  applyLocalFilters() {
    this.isLoadingTableData = true;
    this.tableData = this.productsList;
    // this.partialTableData = [];
    this.applyLocalTenantFilter();
    this.applyLocalDtFilter_ExpiryOn();
    this.applyLocalDtFilter_RegOn();
    this.applyLocalProductTypeFilter();
    this.applyLocalSearchFilter();
    this.applyLocalDtRangeFilter();
    this.applyLocalFirmwareFilter();
    this.applyLocalZtTypeFilter();
    this.applyCloudBackupFilter();
    this.loadDataInParts(0, this.numberofRecordsToLoad, true);
    setTimeout(() => { this.isLoadingTableData = false; }, 0);
  }

  get numberofRecordsToLoad() {
    if (this.tableData.length < LIMIT_INITIAL_LOAD_DATA) {
      return this.tableData.length;
    }
    return  INITIAL_LOAD_DATA;
  }

  applyServerSideFilters() {
    this.resetTableData();
    this.loadProductList('YES', true);
  }

  applyRegDtFilter(e: any) {
    if (this.registeredOnSelectValue === 'custom') {
      this.mutateFilterState('registeredOnSelectValue', this.lastRegFilterIdSelected ? this.lastRegFilterIdSelected : 'all');
      this.mutateFilterState('lastRegFilterIdSelected', 'custom');
    } else {
      this.mutateFilterState('lastRegFilterIdSelected', e);
      this.applyFilters();
    }
  }

  getHeaderIconTooltip(text: string) {
    if (this.isHideIconText && this.isExpandSearchFilter) {
      return {
        placement: 'top',
        compact: true,
        content: text,
      };
    }
    return {
      enabled: false,
    };
  }

  regDateRangeChanged(e: any) {
    const str = e.toString()
    .split('->');
    const dateToday = new Date();
    if ((new Date(str[1]) > dateToday)) {
      const message: InfoState = { infoType: 'high', infoMsg: (this.$t('products.selectedDateExceed')
      .toString()) };
      this.$store.commit('enqueueMessage', message);
      return;
    }
    this.mutateFilterState('registeredOnSelectValue', 'all');
    this.mutateFilterState('selectedDateRange', 'All');
    this.mutateFilterState('regDtRangeValue', e);
    this.mutateFilterState('regDtStartDate', str[0]);
    this.mutateFilterState('regDtEndDate', str[1]);
    this.applyFilters();
  }

  applyFilters() {
    if (this.isAllProductsLoaded) {
      this.applyLocalFilters();
    } else {
      this.applyServerSideFilters();
    }
    this.saveOrResetFilterState();
  }

  resetTableData() {
    this.productsList = [];
    this.tableData = [];
    this.partialTableData = [];
    this.pageNumber = 1;
  }

  resetFilters() {
    this.mutateFilterState('registeredOnSelectValue', 'all');
    this.mutateFilterState('selectedDateRange', 'All');
    this.mutateFilterState('productTypeSelectValue', 'All');
    this.mutateFilterState('regDtStartDate', '');
    this.mutateFilterState('regDtEndDate', '');
    this.mutateFilterState('searchInputChips', []);
    this.mutateFilterState('customDateFilter', '');
    this.mutateFilterState('regDtRangeValue', '');
    this.mutateFilterState('lastRegFilterIdSelected', '');
  }

  setColumnConfigAfterCustomersColRemoval() {
    if (this.selectedCustomer !== this.defaultSelectedCustomer) {
      this.productTableConfig = this.tableConfigArr.filter((column) => {
        return column.key !== 'productGroup';
      });
    } else {
      this.productTableConfig = this.tableConfigArr;
    }
  }

  filterCustomer(search: any) {
    if (search.productGroupId !== this.selectedCustomerId || search.selectedVal === this.defaultSelectedCustomer) {
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: search.selectedVal });
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: search.productGroupId });
      // this.resetFilterbyTenantId();
      this.updateSelectedTenantId(search.selectedVal);
      this.activeFilterButtonStatus = 'total';
      this.resetFilters();
      this.applyFilters();
      this.displayFreeTrial = false;
    }
    this.setColumnConfigAfterCustomersColRemoval();
  }

  updateSelectedTenantId(searchedTenant: string) {
    if (this.$route.query.tenantid) {
      const product = this.customerList.filter((customer: any) => {
        return customer.productGroupName === searchedTenant;
      })[0] || {};
      const { productGroupName, productGroupId } = product;
      if (productGroupName || productGroupId) {
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: productGroupName });
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: productGroupId });
        this.$router.push({ path: 'products', query: { tenantid: productGroupId } });
        (window as { [key: string]: any }).parent.postMessage({ toggleURL: `/m/feature/products?tenantId=${productGroupId}` }, '*');
      } else {
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: searchedTenant });
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: '' });
        this.$router.push({ path: 'products' });
        (window as { [key: string]: any }).parent.postMessage({ toggleURL: '/m/feature/products' }, '*');
      }
    }
  }

  resetFilterbyTenantId() {
    if (this.$route.query.tenantid) {
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: '' });
      if ((window as { [key: string]: any }).top.location !== (window as { [key: string]: any }).location) {
        (window as { [key: string]: any }).parent.postMessage(
          {
            redirectUrl : '/m/feature/products',
          },
          '*',
        );
      }
      this.$router.replace({ path: '/m/feature/products' });
    }
  }

  showDialog() {
    const currentUser = localStorage.getItem(currentUserKey);
    const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    const tenantId = this.customerList.filter((customer: any) => customer.productGroupName === this.selectedCustomer)[0].productGroupId;
    const userName = this.$store.getters.getUserId;
    const queryparams = `?__vm__=embedded&allow=fullscreen&token${token}=&tenantid=${tenantId}&username=${userName}`;
    if (envCongif.env === 'DEV') {
      this.defconDialogSrc = `https://10.206.27.136/m/page/bill-meter${queryparams}`;
    } else if (envCongif.env === 'SIMULATION') {
      this.defconDialogSrc = `https://securitycenterbeta.sonicwall.com/m/page/bill-meter${queryparams}`;
    } else {
      this.defconDialogSrc = `https://securitycenter.sonicwall.com/m/page/bill-meter${queryparams}`;
    }
    this.showDefconDialog = true;
    this.visible = true;
  }

  setConfirmationDialogOptions(actionType: string) {
    let str = '';
    this.inEligibleProductsForAction.forEach((prod) => {
      str += `${prod.serNo} `;
    });
    this.buttons = [
      { key: 'cancel', name: (this.$t('common.cancel')
      .toString()) },
      { key: 'continue', name: (this.$t('common.continue')
      .toString()), isDefault: true },
    ];
    this.options = {
      status: 'high',
      title: 'Warning',
      message: `
      Serial(s) ${str} are not eligible for ${actionType === 'updatezt' ? 'Zero touch update' : actionType}.
      Continue with eligible serials?
      `,
      buttons: this.buttons,
    };
  }

  handleTableScroll() {
    try {
      const mainTable = (this.$refs.tableProducts as SwTable).$el as HTMLElement;
      if (mainTable) {
        const scrollView = (((this.$refs.tableProducts as SwTable).$refs.body as SwTableBody).$refs.bodyCont as HTMLElement);
        scrollView.onscroll = (e: any) => {
          this.openDropMenu = false;
          if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight <= 1)) {
            if (this.partialTableData.length < this.tableData.length) {
              this.onLoadMoreProducts(1);
              // scrollView.updatePercentagePosition(10, true);
            }
          }
        };
      }
    } catch (e) {
      console.error(e);
    }
  }

  isNoneSelectedEligibleForAction(action: string) {
    const flag = this.selectedTableRows.some((product) => {
      return (product[action] === 'YES' || product[action] === true);
    });
    return flag;
  }

  registerProducts() {
    window.parent.postMessage({
      redirectUrl : '/m/feature/register-products?redirectTo=productTab',
    },                        '*');
    this.$router.push({ path: '/m/feature/register-products?redirectTo=productTab' });
  }

  reloadProducts() {
    this.resetTableData();
    this.loadProductList('YES', true, true, true);
  }
  openProductDetail(serialNumber: string, tab: string, productType = '') {
    this.displayProductDetail = true;
    this.expandVisible = false;
    if (tab === 'firmware' || tab === 'licenses' || tab === 'cloudbackups') {
      this.$store.commit('MswProductsStoreModule/setSkipLoading', 'YES');
    }
    this.$store.commit('MswProductsStoreModule/setCurrentTab', { value: 'productdetails', updateOperation: 'assign', updateMode:'id' });
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedSerialNumer', with: serialNumber });
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedProductType', with: productType });
    this.selectedProductTab = tab;
  }

  openVulnerabilityLink(url: string) {
    if (url)
      { window.open(url, '_blank'); }
  }

  get isOpenTransferModal() {
    return this.openMultiProductAction === 'transfer';
  }

  get isOpenDeleteModal() {
    return this.openMultiProductAction === 'delete';
  }

  get isOpenUpdateZTModal() {
    return this.openMultiProductAction === 'updatezt';
  }

  get returnData() {
    const data: TableEntry[] = [];
    this.partialTableData.forEach((entry, index) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = index.toString();
      newEntry._selectable = true;
      data.push(newEntry);
    });
    if (!this.partialTableData.length) {
      return [];
    }
    const compareDate = this.partialTableData[0].dtRegistrationDate;
    const count = this.partialTableData.filter((item: any) => {
      return item.dtRegistrationDate === compareDate;
    }).length;
    if (count === this.partialTableData.length && this.sortedColumns[0] && this.sortedColumns[0].colKey === 'registrationDate') {
      return data.sort((a, b) => {
        const aDate = new Date(a.dtRegistrationDate);
        const bDate = new Date(b.dtRegistrationDate);
        return aDate > bDate ? 1 : -1;
      });
    }
    return data;
  }

  @Watch('selectedDateRange')
  private updateDateFilterTiltle() {
    if (this.$refs.regDtFilterSlider) {
      ((this.$refs.regDtFilterSlider as SwSlider).$refs.sliderBtn as HTMLElement).title = this.selectedDateRange;
    }
  }

  beforeDestroy() {
    document.removeEventListener('click', this.closeUploadModal);
    document.removeEventListener('keyup', this.closeModals);
  }

  destroyed() {
    this.setHelpId('default');
  }

  updated() {
    if (this.openDropMenu) {
      const app = (document.getElementsByClassName('sw-app'))[0];
      app.addEventListener('click', () => {
        this.openDropMenu = false;
      });
    }
  }

  openOptions(event: any, data: any) {
    this.refreshProductDetails(data.serNo);
    let count = 2;
    if (data.isTransferAllowed === 'YES') count += 1;
    if (data.isDeleteAllowed === 'YES') count += 1;
    if (data.cloudBackupTab) count += 1;
    if (data.isZTEnable) count += 1;
    if (data.enableMssp === 'YES') count += 1;
    event.stopPropagation();
    this.openDropMenu = true;
    this.dataMoreActions.rowData = data;
    // const temp = document.getElementsByClassName('sw-scroll-view__view__cont')[0];
    const temp = document.getElementsByClassName('sw-table-body__cont-native')[0];
    if (temp) {
      if ((temp.clientHeight - event.clientY - 48) >= count * 40) {
        this.dataMoreActions.actionsMenuClientY = event.clientY - 15;
        this.dataMoreActions.actionsMenuClientX = event.clientX - 167;
        this.flipOptionsMenu = false;
      } else {
        this.dataMoreActions.actionsMenuClientY = event.clientY + 22 - count * 40;
        this.dataMoreActions.actionsMenuClientX = event.clientX - 167;
        this.flipOptionsMenu = true;
      }
    }
  }
  refreshProductDetails(serNo: any) {
    this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: {} });
    Promise.all([
      this.$store.dispatch('MswProductsStoreModule/getProductDetail', serNo),
      this.$store.dispatch('MswProductsStoreModule/getProductToDoList', serNo),
    ])
    .then((res: any) => {
      // this.checkServiceActivation = false;
      if (res[0].msgCode === 'MSWAPP:SUCCESS') {
        // this.readonly = res[0].isReadOnlyAccess;
        const productDetails = res[0].content.pDetail[0];
        productDetails.isMSSPManaged = res[0].content.pDetail[0].isMSSPManaged === 'YES' ? true : false;
        productDetails.showMSSPManaged = res[0].content.pDetail[0].showMSSPManaged === 'YES' ? true : false;
        this.isTz = res[0].content.pDetail[0].isMSSPFirewallProduct === '1' ? true : false;
        // this.fetchMsspProductSevices(res[0].content.pDetail[0].groupid, res[0].content.pDetail[0].pID);
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'productDetails', with: productDetails });
      }
      if (res[1].msgCode === 'MSWAPP:SUCCESS') {
        // this.toDoList = res[1].content.toDoList;
      }
      this.$store.commit('stopLoading');
    });
  }
  onEntrySelecting(data: TableEntrySelectingEventData) {
    this.commonOnEntrySelecting(data);
  }

  commonOnEntrySelecting(data: TableEntrySelectingEventData) {
    if (data.selecting) {
      this.selectedTableRows.push(this.tableData[Number(data.entryKey)]);
    } else {
      const arrIndexes = this.selectedTableRows.map((item) => { return item._key; });
      const removeIndex = arrIndexes.indexOf(Number(data.entryKey));
      this.selectedTableRows.splice(removeIndex, 1);
    }
  }

  onRequestSorting(data: ColumnSortRequestData) {
    let asc: boolean = true;
    if (data.ascending === false) {
      asc = false;
    } else {
      asc = true;
    }
    const toSend = {
      colKey: data.colKey,
      ascending: asc,
    };
    this.$store.commit('MswProductsStoreModule/saveSort', toSend);
    this.saveOrResetFilterState();
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  sendWidths() {
    this.saveOrResetFilterState();
  }

  onRequestColumnAdjust(data: ColumnsAdjustRequestData) {
    this.productTableConfig.forEach((col) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) { return; }
      Vue.set(col, 'width', adjustInfo);
      this.$store.commit('MswProductsStoreModule/editWidth', { propertyName: col.key, width: adjustInfo });
    });
    this.sendWidths();
  }

  getCustomerList(list: []) {
    this.customerList = list;
    if (this.$route.query.tenantid) {
      const productGroupName = this.customerList.filter((customer: any) => {
        return  customer.productGroupId === this.$route.query.tenantid.toString();
      })[0].productGroupName || '';
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: productGroupName });
      this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomerId', with: this.$route.query.tenantid.toString() });
    }
    this.applyLocalTenantFilter();
    this.ifSelectedTenantDeleted();
  }

  deSelectRows() {
    this.selectedTableRows = [];
    const vm = this.$refs.tableProducts as SwTable;
    if (vm) {
      vm.selectedSet.forEach((entryKey: any) => {
        this.onEntrySelecting({ entryKey, selecting: false } as TableEntrySelectingEventData);
        vm.$emit('entry-selecting', { entryKey, selecting: false } as TableEntrySelectingEventData);
      });
      vm.selectedSet.clear();
      this.tableData = this.tableData.slice();
    }
  }

  getShieldValue() {
    return this.shieldValue;
  }

  getDefConProgressValue() {
    return this.defConProgressValue;
  }

  closeProductDetail(refreshList: boolean) {
    this.displayProductDetail = false;
    refreshList && (this.resetTableData(), this.loadProductList('YES', true));
  }
  get showFreeTrailButton() {
    return this.selectedCustomer !== this.defaultSelectedCustomer;
  }
  closeFreeTrial() {
    this.displayFreeTrial = false;
  }
  getProductGroupId() {
    const tenantId = this.customerList.filter((customer: any) => customer.productGroupName === this.selectedCustomer)[0].productGroupId;
    return tenantId;
  }
  navigateToProductDetails(serial: any) {
    this.openProductDetail(serial, 'productdetails');
  }

  removeFilterChips() {
    this.resetTableData();
    this.loadProductList();
    this.saveOrResetFilterState();
  }

  get isHideIconText() {
    return this.screenWidth < 1486;
  }

  closeUploadModal() {
    this.isOpenFileUpload = false;
    // if (this.isOpenFileUpload) {
    //   const modalElement = document.getElementById('uploadModal') as HTMLElement;
    //   if (!(modalElement.contains(event.target) || event.target.innerText.indexOf('Upload') > -1 || event.target.className.indexOf('icon-upload') > -1)) {
    //     this.isOpenFileUpload = false;
    //   }
    // }
  }
  // Utilities

  friendlyNameColumnRenderer(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    return (
      <div class="friendlyname_col">
        <div class="friendlyname_col_text_field">
          <span class="friendlyname_col_text first_col_text"
                title = {data.entry.friendlyName}
                style={{  color: data.entry.isNFRProduct && data.entry.isNFRProduct === 'YES' ? 'red' : '' }}      >
          { data.entry.friendlyName }
          </span>
          <span class= { data.entry.isRenameAllowed.trim() === 'NO' ? 'hideElement' : 'friendlyname_col_icon' }
              onClick={() => {
                data.entry.friendlyNameBeforeEdit = data.entry.friendlyName;
                this.editFriendlyName(data, true);
              }
          }>
          </span>
        </div>
        <div class="friendlyname_col_edit_text">
          <SwTextfield
            v-tooltip={{
              enabled: !data.entry.friendlyName.trim(),
              placement: 'top',
              persistent: true,
              compact: true,
              content: (this.$t('products.friendlyNameEmpty')
              .toString()),
            }}
            name={data.entry.friendlyName}
            props-value = {data.entry.friendlyName}
            on-input={(e:any) =>
              { if (e.length <= 50) data.entry.friendlyName = e; }
            }
          ></SwTextfield>
          <SwIcon class="friendlyname_col_true_icon" props-size={14} name="checkmark" color="#99CC00"
            nativeOn-click={() => {
              if (data.entry.friendlyName.trim().length > 0) {
                this.renameProduct(data);
                this.editFriendlyName(data, false);
              }
            }
          }></SwIcon>
          <span  style="borderRight:1px solid #C6D1DE">&nbsp;</span>
          <SwIcon class="friendlyname_col_true_icon" props-size={12} name="close" color="#ff0000"
            nativeOn-click={() => {
              data.entry.friendlyName = data.entry.friendlyNameBeforeEdit;
              this.editFriendlyName(data, false);
            }
          }></SwIcon>
        </div>
        </div>
      ) as VNode;
  }

  actionsColumnRenderer(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    return (
      <div class="last_col_actions">
        <span v-tooltip={{ content: 'Activate service', compact: true }} onClick={() => { this.openProductDetail(data.entry.serNo, 'licenses'); }}>
          <span class="action_key_icon"></span>
        </span>
        <span v-tooltip={{ content: data.entry.expTooltip, enabled: data.entry.expTooltip ? true : false, compact: true }}
          onClick={(e: any) => { e.stopPropagation(); }}>
          <div class={data.entry.isLicenseExpired ? 'icon_dot code_red action-col-dot' : 'hideElement'}></div>
          <div class={ !data.entry.isLicenseExpired && data.entry.isLicenseExpiring ? 'icon_dot code_yellow action-col-dot' : 'hideElement'}></div>
        </span>
        <span v-tooltip={{ content: 'More actions', compact: true }} style="margin-top: 3px" onClick={(e: any) => this.openOptions(e, data.entry)}>
          <sw-icon name="more" rotate={90} size="small"></sw-icon>
        </span>
      </div>
    ) as VNode;
  }


  firmwareColumnRenderer(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    enum Severity {
    Critical = 'critical',
    High = 'high',
    Medium = 'medium',
    Low = 'low',
    NotDefined = 'not defined',
    }

    let iconValue = { name: '', color: '' };

    switch (data.entry.vulSev.toLowerCase()) {
      case Severity.Critical:
        iconValue = { name: 'severity-critical', color: '#CC0000' };
        break;
      case Severity.High:
        iconValue = { name: 'severity-high', color: '#FF9900' };
        break;
      case Severity.Medium:
        iconValue = { name: 'severity-major', color: '#FFCC00' };
        break;
      case Severity.Low:
        iconValue = { name: 'severity-low', color: '#99CC00' };
        break;
      case Severity.NotDefined:
        iconValue = { name: 'severity-minor', color: '#47AFE8' };
        break;
      default:
        iconValue = { name: '', color: '' };
    }

    return (
      <div class="last_col_actions">
        <span onClick={(e: any) => { e.stopPropagation(); }}>
          <span>{ data.entry.firmwareVersion }</span>
        </span>
        <span onClick={(e: any) => { e.stopPropagation(); }}>
          <span class={ data.entry.firmwareVersion && data.entry.firmwareStatus ? 'newfirmware_icon' : '' }></span>
        </span>
        { data.entry.vulTT !== '' && data.entry.vulSev ?
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginLeft: 'auto' }}
              onClick={() => { this.openVulnerabilityLink(data.entry.vulHref); }}>
                <sw-icon
                  name={[iconValue.name]}
                  v-tooltip={{
                    compact: true,
                    placement: 'top',
                    content: data.entry.vulTT,
                  }}
              color={[iconValue.color]}
              size="medium"
            ></sw-icon>
          </span> : null }
      </div>
    ) as VNode;
  }

  get tableHeight() {
    const freeTrialButtonHeight: string = this.showFreeTrailButton ? '50px' : '0px';
    if (this.expandVisible) {
      return this.isIframed ? `calc(100vh - 185px - 215px -${freeTrialButtonHeight})` : `calc(100vh - 300px - 215px - ${freeTrialButtonHeight})`;
    }
    return this.isIframed ? `calc(100vh - 185px - ${freeTrialButtonHeight})` : `calc(100vh - 300px - ${freeTrialButtonHeight})`;
  }

  filterTabRenderer(h: CreateElement, data: TabRenderData): VNode {// tslint:disable-line
    switch (data.props.tabId) {
      case 'expiring':
        return (
          <div class="table-filters-top">
            <div class="icon_filter">
              <SwIcon class="" name="announcement" size="xlarge" color="#FF791A"></SwIcon>
            </div>
            <div class="line"></div>
            <div class="info">
              <div class="label">{this.$t('products.licenceAlerts')
                  .toString()}</div>
              <div class="number">{this.expiryAlerts}</div>
            </div>
          </div>
        ) as VNode;
      case 'updates':
        return (
          <div class="table-filters-top">
            <div class="icon_filter">
              <SwIcon class="" name="new" size="xlarge" color="#FF791A"></SwIcon>
            </div>
            <div class="line"></div>
            <div class="info">
              <div class="label">{this.$t('products.updatesAvailables')
                  .toString()}</div>
              <div class="number">{this.updatesAvailable}</div>
            </div>
          </div>
        ) as VNode;
      default:
        return (
          <div class="table-filters-top">
            <div class="icon_filter">
              <SwIcon class="" name="app" size="xlarge" color="#FF791A"></SwIcon>
            </div>
            <div class="line"></div>
            <div class="info">
              <div class="label">{this.$t('products.totalProducts')
                  .toString()}</div>
              <div class="number">{this.totalProductCount}</div>
            </div>
          </div>
        ) as VNode;
    }
  }

  csvToJson(csv: any) {
    const result :any[] = [];
    const headers = csv[0].split(',');
    csv.forEach((item: any, index: number) => {
      if (index !== 0) {
        const obj: any = {};
        const currentline = item.split(',');
        headers.forEach((item: any, index: number) => {
          obj[item.toLowerCase()
          .replace(/ +/g, '')] = currentline[index];
        });
        result.push(obj);
      }
    });
    return result;
  }

  getUploadCsvData(fileTextLines :any) {
    // const jsonData = this.csvToJson(fileTextLines);
    const arrSerials: any[] = [];
    fileTextLines.forEach((item: any) => {
      const inner : any  = {};
      if (item.serialnumber || item['Serial no.']) {
        inner['serialNumber'] = item.serialnumber || item['Serial no.'];
        inner['firmware'] = item.Firmware;
        inner['friendlyName'] = item.friendlyname || item['Friendly name'];
        arrSerials.push(inner);
      }
    });
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/uploadCsv', { updateFwReq: arrSerials })
    .then((resp) => {
      if (resp.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
        if (this.$store.getters.isLargeCustomer) {
          const mappedAr = arrSerials.map((item) => {
            return { entry: { serNo: item.serialNumber, friendlyName: item.friendlyName } };
          });
          this.saveFriendlyNameListToStore(mappedAr);
        } else {
          this.resetTableData();
          this.loadProductList('YES', true);
        }
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }

  allOfThemReadOnlyCheck() {
    if (this.customerList.length > 0) {
      if (this.customerList.every((customer) => { return customer.isReadOnlyAccess === 'YES'; })) {
        this.showMultiServiceActivation = false;
      } else {
        this.showMultiServiceActivation = true;
      }
    }
  }

  // Local Filters

  applyLocalTenantFilter() {
    const customerReadOnly = this.customerList.filter((customer) => {
      if (this.selectedCustomerId === customer.productGroupId) {
        return customer;
      }
    });
    if (customerReadOnly.length) {
      this.showMultiServiceActivation = customerReadOnly[0].isReadOnlyAccess === 'NO';
    }
    if (this.selectedCustomer !== defaultSelectedCustomer) {
      if (this.selectedCustomerId) {
        this.tableData = this.tableData.filter((product) => {
          return product.productGroupId === this.selectedCustomerId;
        });
      } else {
        this.tableData = this.tableData.filter((product) => {
          return product.productGroup.toLowerCase()
          .replace(/&amp;/g, '&') === this.selectedCustomer.replace(/&amp;/g, '&')
          .toLowerCase();
        });
      }
    } else {
      this.tableData = this.productsList;
      this.allOfThemReadOnlyCheck();

    }
    this.totalProductCount = this.tableData.length;
    // update expiry alerts based on tenant
    this.expiryAlerts = this.tableData
    .filter(item => item.isLicenseExpiring || item.isLicenseExpired).length
    .toString();
    // update updates based on tenant
    this.updatesAvailable = this.tableData
    .filter(item => item.isDownloadAvailable).length
    .toString();

    this.applyLicenseExpiryFilter();
    this.applyUpdatesAvailableFilter();
  }

  applyLicenseExpiryFilter() {
    if (this.activeFilterButtonStatus === 'expiring') {
      this.tableData = this.tableData.filter(item => item.isLicenseExpiring || item.isLicenseExpired);
    }
  }

  applyUpdatesAvailableFilter() {
    if (this.activeFilterButtonStatus === 'updates') {
      this.tableData = this.tableData.filter(item => item.isDownloadAvailable);
    }
  }

  applyLocalDtFilter_RegOn() {
    this.tableData = this.tableData.filter((product) => {
      return this.dateFilterInput(this.registeredOnSelectValue, product.dtRegistrationDate);
    });
  }

  applyLocalDtFilter_ExpiryOn() {
    this.tableData = this.tableData.filter((product) => {
      return this.dateFilterInput(this.expiringOnSelectVal, this.expiringOnSelectVal.indexOf('-') > -1 ? product.dtExpired : product.dtExpiring);
    });
  }

  dateFilterInput(value: any, dateField: any) {
    switch (value) {
      case '>90':
        const greaterThan90: Date = new Date();
        greaterThan90.setDate(new Date().getDate() + 90);
        return dateField && new Date(dateField) > greaterThan90;
        break;
      case '90':
        const day90: Date = new Date();
        day90.setDate(new Date().getDate() + 90);
        return dateField && new Date(dateField) <= day90 && new Date(dateField) > new Date();
        break;
      case '30':
        const day30: Date = new Date();
        day30.setDate(new Date().getDate() + 30);
        return dateField && new Date(dateField) <= day30 && new Date(dateField) > new Date();
        break;
      case '7':
        const day7: Date = new Date();
        day7.setDate(new Date().getDate() + 7);
        return dateField && new Date(dateField) <= day7 && new Date(dateField) > new Date();
        break;
      case '0':
        const today: Date = new Date();
        const regDate1 = new Date(dateField);
        return dateField && regDate1.getDate() === today.getDate() && regDate1.getMonth() === today.getMonth()
          && regDate1.getFullYear() === today.getFullYear();
        break;
      case '-1':
        const yesterday: Date = new Date();
        yesterday.setDate(new Date().getDate() - 1);
        const regDate2 = new Date(dateField);
        return dateField && (regDate2.getDate() === yesterday.getDate()) && (regDate2.getMonth() === yesterday.getMonth())
          && (regDate2.getFullYear() === yesterday.getFullYear());
        break;
      case '-7':
        const last7days: Date = new Date();
        last7days.setDate(new Date().getDate() - 7);
        last7days.setHours(0, 0, 0, 0);
        return dateField && new Date(dateField) >= last7days && new Date(dateField) <= new Date();
        break;
      case '-30':
        const last30days: Date = new Date();
        last30days.setDate(new Date().getDate() - 30);
        last30days.setHours(0, 0, 0, 0);
        return dateField && new Date(dateField) >= last30days && new Date(dateField) <= new Date();
        break;
      case '-90':
        const last90days: Date = new Date();
        last90days.setDate(new Date().getDate() - 90);
        last90days.setHours(0, 0, 0, 0);
        return dateField && new Date(dateField) >= last90days && new Date(dateField) <= new Date();
        break;
      case '-180':
        const last180days: Date = new Date();
        last180days.setDate(new Date().getDate() - 180);
        last180days.setHours(0, 0, 0, 0);
        return dateField && new Date(dateField) >= last180days && new Date(dateField) <= new Date();
        break;
      default:
        return true;
    }
  }

  applyLocalDtRangeFilter() {
    if (this.regDtStartDate && this.regDtEndDate) {
      this.tableData = this.tableData.filter((product) => {
        return product.dtRegistrationDate && (new Date(product.dtRegistrationDate) >= new Date(this.regDtStartDate)) &&
        (new Date(product.dtRegistrationDate) <= new Date(this.regDtEndDate));
      });
    }
  }

  applyLocalProductTypeFilter() {
    if (this.productTypeSelectValue.toLowerCase() !== 'all') {
      this.tableData = this.tableData.filter((product) => {
        return product.productType.toLowerCase() === this.productTypeSelectValue.toLowerCase();
      });
    }
  }

  applyLocalFirmwareFilter() {
    if (!this.firmwareFilterValue) return;
    this.tableData = this.tableData.filter((product) => {
      if (!product.firmwareVersion) {
        return false;
      }
      return product.firmwareVersion.startsWith(this.firmwareFilterValue);
    });
  }

  applyLocalZtTypeFilter() {
    if (this.ztTypeSelectedValue) {
      this.tableData = this.tableData.filter((product) => {
        switch (this.ztTypeSelectedValue) {
          case 'csc':
            return product.isZTEnable && product.ztValue === '1';
            break;
          case 'gms':
            return product.isZTEnable && product.ztValue === '0';
            break;
          case 'none':
            return !product.isZTEnable;
            break;
          default:
            return true;
        }
      });
    }
  }

  applyCloudBackupFilter() {
    if (this.cloudBackupsSelectedValue) {
      this.tableData = this.tableData.filter((product) => {
        switch (this.cloudBackupsSelectedValue) {
          case 'YES':
            return product.Hascloudbackups && product.Hascloudbackups === 'YES';
            break;
          case 'NO':
            return product.Hascloudbackups && product.Hascloudbackups === 'NO';
            break;
          default:
            return true;
        }
      });
    }
  }

  applyLocalSearchFilter() {
    this.searchInputChips.forEach((item) => {
      if (item.trim()) {
        this.tableData = this.tableData.filter((product) => {
          return product.friendlyName.toLowerCase()
          .includes(item.trim()
          .toLowerCase()) ||
          product.serNo.toLowerCase()
          .includes(item.trim()
          .toLowerCase());
        });
        if (!this.tableData.length) {
          if (this.apiRequestLimiter === 0) {
            this.apiRequestLimiter += 1;
            this.loadProductList('YES', true);
          }
        }
      }
    });
  }

  multiProductAction(type: string) {
    if (type === 'transfer') this.customerToExcludeInTransfer = this.selectedCustomer;
    let filterParam:string = '';
    switch (type) {
      case 'transfer':
        filterParam = 'isTransferAllowed';
        break;
      case 'delete':
        filterParam = 'isDeleteAllowed';
        break;
      case 'updatezt':
        filterParam = 'isZTEnable';
        break;
    }
    this.selectedProductsForActions = [];
    this.inEligibleProductsForAction = [];
    this.selectedTableRows.filter((product) => {
      if (product[filterParam] === 'YES' || product[filterParam] === true) {
        this.selectedProductsForActions.push(product);
      } else {

      }
    });
    this.inEligibleProductsForAction = this.selectedTableRows.filter((product) => {
      return product[filterParam] !== 'YES' && product[filterParam] !== true;
    });

    if (this.inEligibleProductsForAction.length > 0) {
      this.setConfirmationDialogOptions(type);
      confirmService.confirm(this.options)
      .then((key) => {
        if (key === 'continue') {
          // this.openMultiProductAction = type as 'transfer'|'delete'|'updatezt'|'';
          if (this.selectedProductsForActions.length > 0) {
            this.openMultiProductAction = type as 'transfer'|'delete'|'updatezt'|'';
          } else {
            // tslint:disable-next-line:max-line-length
            const message: InfoState = { infoType: 'high', infoMsg: `${ this.inEligibleProductsForAction.length === 1 ? 'Selected product' : 'Multiple products' }  ${type} operation is not possible` };
            this.$store.commit('enqueueMessage', message);
          }
        }
      });
    } else {
      if (this.selectedProductsForActions.length > 0) {
        this.openMultiProductAction = type as 'transfer'|'delete'|'updatezt'|'';
      } else {
        // tslint:disable-next-line:max-line-length
        const message: InfoState = { infoType: 'high', infoMsg: `${ this.inEligibleProductsForAction.length === 1 ? 'Selected product' : 'Multiple products' } ${type} operation is not possible` };
        this.$store.commit('enqueueMessage', message);
      }
    }
  }

  handleRowAction(actionid: string) {
    switch (actionid) {
      case 'info':
        this.openProductDetail(this.dataMoreActions.rowData.serNo, 'productdetails');
        break;
      case 'export':
        this.exportCsv([this.dataMoreActions.rowData]);
        break;
      case 'transfer':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.customerToExcludeInTransfer = this.dataMoreActions.rowData.productGroup;
        this.openMultiProductAction = 'transfer';
        break;
      case 'delete':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.openMultiProductAction = 'delete';
        break;
      case 'deletecloudbackup':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.deleteCloudBackup({}, false);
        break;
      case 'updatezt':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.openMultiProductAction = 'updatezt';
        break;
      case 'msspEnable':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.handleEnroll(true);
        break;
      case 'msspDisable':
        this.selectedProductsForActions = [];
        this.selectedProductsForActions.push(this.dataMoreActions.rowData);
        this.handleEnroll(false);
        break;
      case 'cloudbackups':
        this.openProductDetail(this.dataMoreActions.rowData.serNo, 'cloudbackups');
        // this.$store.dispatch('navigateTo', `ui/productsgrid?serNo=${this.dataMoreActions.rowData.serNo}&openTab=cloudTab`);
    }
  }
  deleteCloudBackup(data: any, singleEntry: boolean) {
    confirmService.confirm({
      status: 'major',
      title: (this.$t('products.deleteCloudBackups')
      .toString()),
      message:(this.$t('products.deleteCloudBackupMessage')
      .toString()),
      buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.handelDeleteCloudBackup(data, singleEntry);
      }
    });
  }
  handelDeleteCloudBackup(selectedProduct: any, singleEntry: boolean) {
    const payload: {
      overrideDeleteValidate: string;
      ProdsDeleteCloudBackUpList: { index: number; serialNumber: any }[];
    } = {
      overrideDeleteValidate: 'NO',
      ProdsDeleteCloudBackUpList:[],
    };
    if (singleEntry) {
      const selectedSerial: any[] = [];
      selectedProduct.forEach((item: any, index: number) => {
        selectedSerial.push({ index, serialNumber:item.serNo });
      });
      payload.ProdsDeleteCloudBackUpList = selectedSerial;
    } else {
      payload.ProdsDeleteCloudBackUpList.push({ index:0, serialNumber:this.selectedProductsForActions[0].serNo });
    }
    this.$store.dispatch('MswProductsStoreModule/deleteCloudBackups', payload)
     .then((response: any) => {
       this.$store.commit('stopLoading');
       if (response.operationStatus === 'OK') {
         this.$emit('detailsUpdated');
         confirmService.confirm({
           status: 'success',
           title:(this.$t('products.deleteCloudBackups')
          .toString()),
           message:(response.msgDesc || ''),
           buttons: [{ key: 'ok', name: 'Ok', isDefault: true }],
         });
         this.resetTableData(); this.loadProductList('YES', true, true, true);
       } else {
         confirmService.confirm({
           status: 'failed',
           title:(this.$t('products.deleteCloudBackups')
           .toString()),
           message:(response.msgDesc || ''),
           buttons: [{ key: 'ok', name: 'Ok', isDefault: true }],
         });
         this.$emit('detailsUpdated');
       }
     })
     .catch(() => {
       this.$store.commit('stopLoading');
     });
  }
  handleEnroll(value: boolean) {
    if (value) {
      this.showMSSPMonthlyManagedDialog = true;
      // confirmService.confirm({
      //   status: 'major',
      //   title: 'MSSP monthly',
      //   message:'By Managing this device from MSSP, any existing active subscriptions done outside of MSSP Monthly would be lost. Are you sure you want to do this ?',
      //   buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
      // })
      // .then((isConfirmed : any) => {
      //   if (isConfirmed === 'ok') {
      //     this.handleEnrollDerollApi(value);
      //   } else {
      //     this.msspManaged = !this.msspManaged;
      //   }
      // });
    } else {
      confirmService.confirm({
        status: 'major',
        title: 'MSSP monthly',
        message:(this.$t('products.movingOutOfMSSPmsg')
        .toString()),
        buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
      })
      .then((isConfirmed : any) => {
        if (isConfirmed === 'ok') {
          this.handleEnrollDerollApi(value);
        } else {
          // this.msspManaged = !this.msspManaged;
          // this.resetTableData();  // this.loadProductList('YES', true, true, true);
        }
      });
    }
  }
  closeMSSPMonthlyManaged(val: any) {
    this.showMSSPMonthlyManagedDialog = false;
    if (val === true) {
      this.showMSSPMonthlyManagedDialog = false;
    } else {
      // this.msspManaged = !this.msspManaged;
      this.resetTableData(); this.loadProductList('YES', true, true, true);
    }
    this.resetTableData(); this.loadProductList('YES', true, true, true);
  }

  handleEnrollDerollApi(value: boolean) {
    const enrollDerollMssp: any = {
      serialNumber: this.selectedProductsForActions[0].serNo,
      Mode: value ? 'ENROLL' : 'DEROLL',
    };
    this.$store.dispatch('MswProductsStoreModule/enrollDerollMssp', enrollDerollMssp)
     .then((response: any) => {
       this.$store.commit('stopLoading');
       if (response.operationStatus === 'OK') {
         this.$emit('detailsUpdated');
         this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
       } else {
        //  this.msspManaged = !this.msspManaged;
         this.resetTableData(); this.loadProductList('YES', true, true, true);
         this.$emit('detailsUpdated');
         this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
       }
       this.resetTableData(); this.loadProductList('YES', true, true, true);
     })
     .catch(() => {
       this.$store.commit('stopLoading');
     });
  }
  handleDateFilter(view: string, type: 'registeredOn'|'expiringOn') {
    switch (view) {
      case 'After next 90 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '>90');
        break;
      case 'Next 90 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '90');
        break;
      case 'Next 30 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '30');
        break;
      case 'Next 7 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '7');
        break;
      case 'Today':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '0');
        break;
      case 'Yesterday':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '-1');
        break;
      case 'Last 7 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '-7');
        break;
      case 'Last 30 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '-30');
        break;
      case 'Last 90 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '-90');
        break;
      case 'Last 180 days':
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', '-180');
        break;
      default:
        this.mutateFilterState(type === 'registeredOn' ? 'registeredOnSelectValue' : 'expiringOnSelectVal', 'all');
        break;
    }
  }

  mapDataForExport(csvData: any[], isXls: any) {
    const filterJson: any = [];
    const itemHeader = ['Friendly name', 'Serial no.', 'Tenants', 'Product type', 'Product name', 'Registered on', 'Licenses', 'Support', 'Firmware', 'Cloud Backups Stored'];
    !isXls && filterJson.unshift(itemHeader);
    csvData.map((dataItem:any) => {
      const obj = {};
      this.selectedColumnsConfig.forEach((item) => {
        // // @ts-ignore
        if (item.dataKey && item.dataKey !== 'actions') {
          if (item.title === 'Product name') {
            // @ts-ignore
            obj[item.title] = this.removeHtmlTags(dataItem[item.dataKey]);
          } else if (item.title === 'Serial number') {
            // @ts-ignore
            obj[item.title] = `${dataItem[item.dataKey]?.toString()}`;
          } else if (item.title === 'Licenses') {
            let totalCount = 0;
            // tslint:disable-next-line:max-line-length
            const isUnlimited = dataItem['ccNodeCount'] === 'Unlimited' || dataItem['hesNodeCount'] === 'Unlimited' || dataItem['gmsNodeCount'] === 'Unlimited' || dataItem['saseNodeCount'] === 'Unlimited' || dataItem['casNodeCount'] === 'Unlimited';
            if (!isUnlimited) {
              totalCount = Number(dataItem['ccNodeCount'] ? dataItem['ccNodeCount'] : '0') +
                 Number(dataItem['hesNodeCount'] ? dataItem['hesNodeCount'] : '0') +
                 Number(dataItem['gmsNodeCount'] ? dataItem['gmsNodeCount'] : '0') +
                 Number(dataItem['casNodeCount'] ? dataItem['casNodeCount'] : '0') +
                 Number(dataItem['saseNodeCount'] ? dataItem['saseNodeCount'] : '0');
            // @ts-ignore
              obj[item.title] = totalCount.toString();
            } else {
            // @ts-ignore
              obj[item.title] = 'Unlimited';
            }
          } else if ((item.dataKey === 'dtRegistrationDate' && dataItem[item.dataKey]) || (item.dataKey === 'dtSupportExpiry' && dataItem[item.dataKey])) {
            const date = dataItem[item.dataKey]?.split('/')[2];
            const month = dataItem[item.dataKey]?.split('/')[1];
            const year = dataItem[item.dataKey]?.split('/')[0];
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            // @ts-ignore
            obj[item.title] = `${months[month - 1]} ${date} ${year}`;
          } else {
            if (dataItem[item.dataKey]) {
              // @ts-ignore
              obj[item.title] = dataItem[item.dataKey]?.toString();
            } else {
              // @ts-ignore
              obj[item.title] = dataItem[item.dataKey] === 0 ? '0' : '';
            }
          }
        }
      });
      filterJson.push(obj);
    });
    return filterJson;
  }

  removeHtmlTags(str: any) {
    return str.toString()
    .replace(/(<([^>]+)>)/ig, '');
  }

  ifSelectedTenantDeleted() {
    if (this.customerList && this.customerList.length) {
      const arr = this.customerList.filter((item) => {
        return item.productGroupName === this.selectedCustomer;
      });
      if (!arr.length && this.selectedCustomer.toLowerCase() !== 'all tenants') {
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'selectedCustomer', with: defaultSelectedCustomer });
        // this.saveOrResetFilterState();
        this.loadProductList();
      }
    }
  }

  exportCsv(data: any[], fullData = false) {
    if (data.length !== 0) {
      if (fullData) { // earlier changed condition fullData && data.length === this.totalProductCount
        ExportcsvService.startExport(this.mapDataForExport(data, false), 'Products.csv');
      } else if (!fullData) {
        ExportcsvService.startExport(this.mapDataForExport(data, false), 'Products.csv');
      }
    }
  }

  exportCsvAll() {
    // old function to export all or some from product type filter
    if (this.productTypeSelectValue.toLowerCase() === 'all' && this.productsList.length > 0) {
      this.exportCsv(this.productsList);
    } else if (this.productsList.length > 0 && this.partialTableData.length !== 0) {
      const filteredProductType: any[] = [];
      try {
        this.productsList.forEach((el) => {
          if (el.productType.toLowerCase() === this.productTypeSelectValue.toLowerCase()) {
            filteredProductType.push(el);
          }
        });
        this.exportCsv(filteredProductType);
      } catch (e) {
        console.warn(e);
      }
    }
  }

  exportToExcel() {
    const XLSX = require('xlsx');
    // const headers = [['FirstName', 'Last Name', 'Email', 'Formatted Date']];
    const dataToExport = this.mapDataForExport(this.tableData, true)
    .map((item: any) => {
      return {
        ...item,
        Support: item?.Support ? new Date(item.Support) : '',
        // 'Registered on': item['Registered on'] ? new Date(item['Registered on']) : '',
      };
    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    // XLSX.utils.sheet_add_aoa(ws, headers);
    XLSX.utils.sheet_add_json(ws, dataToExport, {
      origin: 'A1',
      skipHeader: false,
      cellDates: true,
      dateNF: 'MMM DD yyyy',
    });
    XLSX.utils.book_append_sheet(wb, ws, 'Products');
    XLSX.writeFile(wb, 'Products.xlsx');
  }

  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv(this.tableData, true);
    } else {
      this.exportToExcel();
    }
  }

  closeModals() {
    this.openMultiProductAction = '';
    this.showDefconDialog = false;
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }
  registeredDataUpdate(resp : any) {
    // && resp.hasOwnProperty('content')
    const storedSerNo = localStorage.getItem('registeredData');
    if (storedSerNo !== null && storedSerNo !== undefined && resp.hasOwnProperty('content')) {
      const storedDataObj = JSON.parse(storedSerNo);
      if (storedDataObj.length > 0) {
        storedDataObj.forEach((ele : any, index: any) => {
          if (ele.serNo.trim()
          .toLowerCase() === resp.content.pDetail[0].serialNumber.trim()
          .toLowerCase()) {
            if (resp.content.pDetail[0].hasOwnProperty('pID')) {
              storedDataObj[index].pID = resp.content.pDetail[0].pID;
            }
            if (resp.content.pDetail[0].hasOwnProperty('productDesc')) {
              storedDataObj[index].productDesc = resp.content.pDetail[0].productDesc;
            }
            if (resp.content.pDetail[0].hasOwnProperty('productDesc')) {
              storedDataObj[index].productDesc = resp.content.pDetail[0].productDesc;
              storedDataObj[index].productName = resp.content.pDetail[0].productDesc;
            }
            if (resp.content.pDetail[0].hasOwnProperty('friendlyName')) {
              storedDataObj[index].friendlyName = resp.content.pDetail[0].friendlyName;
            }
            if (resp.content.pDetail[0].hasOwnProperty('pFamily')) {
              storedDataObj[index].productType = resp.content.pDetail[0].pFamily;
            }
            if (resp.content.pDetail[0].hasOwnProperty('firmwareVersion')) {
              storedDataObj[index].firmwareVersion = resp.content.pDetail[0].firmwareVersion;
            }
            if (resp.content.pDetail[0].hasOwnProperty('groupName')) {
              storedDataObj[index].productGroup = resp.content.pDetail[0].groupName;
            }
          }
        });
        localStorage.setItem('registeredData', JSON.stringify(storedDataObj));
        this.loadProductList('NO', false);
      }
    }
  }
}
